export function AnalyticsTracking() {
  return <script defer src="https://cloud.umami.is/script.js" data-website-id="3525a6b4-8f2e-41e1-9895-9333c465d5d0" />;
}
